export default "__VITE_ASSET__aadfa65f__"